import { render, staticRenderFns } from "./AdherenceIndicatorsHeader.vue?vue&type=template&id=53b5e7fc&scoped=true&"
import script from "./AdherenceIndicatorsHeader.vue?vue&type=script&lang=js&"
export * from "./AdherenceIndicatorsHeader.vue?vue&type=script&lang=js&"
import style0 from "./AdherenceIndicatorsHeader.vue?vue&type=style&index=0&id=53b5e7fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b5e7fc",
  null
  
)

export default component.exports